var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgYoutubeShorts = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14.401.529c2.264-1.18 5.067-.32 6.258 1.92 1.191 2.24.322 5.012-1.941 6.191l-1.862.979a4.635 4.635 0 0 1 3.934 2.445c1.191 2.24.324 5.012-1.942 6.192L8.923 23.47c-2.264 1.18-5.067.32-6.258-1.92-1.192-2.24-.322-5.011 1.941-6.19l1.862-.98a4.635 4.635 0 0 1-3.934-2.445c-1.191-2.24-.322-5.011 1.941-6.191L14.401.529ZM9.044 8.306l6.008 3.71-6.008 3.69v-7.4Z",
  fill: "#FB3958"
})));
export default SvgYoutubeShorts;